import IndexTableRow from '../index-table/IndexTableRow'
import ProjectConfigurationsIndexTableRowRenderer from './ProjectConfigurationsIndexTableRowRenderer'
import ValueFormatter from '../utils/ValueFormatter';
import ProjectStore from '../../store/projectStore';
import TypingTester from '@lib/TypingTester'
import _ from 'lodash'

export default class ProjectConfigurationIndexTableRow extends IndexTableRow {
    state = {
        numberInputRefId: null
    }

    constructor(props) {
        super(props);
        this.tester = new TypingTester(20);
        this.state.setProductSerialNumberModal = false;
        this.state.requiredProjectSaveModal = false;
    }

    loadRowRenderer() {
        this.rowRenderer = new ProjectConfigurationsIndexTableRowRenderer(this.props, this);
    }

    onDeleteClick = (button, editApiService) => {
        this.props.onRemoveRowClick(this.props.row.guid)
    }

    renderNumberInput = (id, value, onChange, warning) => {
        const formattedValue = this.getDiscountValue(value).toFixed(2);

        const attrs = {
            defaultValue: formattedValue
        }

        if (this.state.numberInputRefId && this.state.numberInputRefId !== id) {
            attrs.value = formattedValue;
        } else if (this.numberInputRefId) {
            attrs.value = value;
        }

        if (warning) {
            attrs.className = 'force-to-change'
        }

        return (
            <input
                id={id}
                type="text"
                pattern="\d"
                {...attrs}
                onChange={e => {
                    let currentValue = e.target.value.replace(',', '.');
                    let decimalValue = ValueFormatter.decimal(e.target.value, formattedValue);
                    e.target.value = decimalValue;
                    this.setState({
                        numberInputRefId: e.target.id
                    }, () => {
                        var number = Number(currentValue).toFixed(2);
                        onChange(number)
                    })

                }}
            />
        )
    }

    salesPriceDiscountVisible = () => ProjectStore.formModel.summary.totalPrice.visible;

    renderPriceColumn(column, value) {
        if (ProjectStore.discountsDuringEdit) {
            return (
                <td className="configuration-price-column-container --sales-price">
                    <span className="configuration-price-column-container-content">
                        <span>{value}</span>
                        <div className="price-and-discount">
                            <div>
                                {this.renderNumberInput(`${this.props.row.id}-discount`, this.props.row.discountValue, value => {
                                    this.tester.record(() => {
                                        this.props.onConfiguratioRowPriceChanged('discountValue', this.props.row.guid, value);
                                    })
                                }, this.props.row.discountValueWarning)}
                                <span className="unit">%</span>
                            </div>
                            <div>
                                {this.renderNumberInput(`${this.props.row.id}-discounted-price`, this.props.row.discountedPriceValue, value => {
                                    this.tester.record(() => {
                                        this.props.onConfiguratioRowPriceChanged('discountedPriceValue', this.props.row.guid, value);
                                    })
                                })}
                                <span className="unit">EUR</span>
                            </div>
                        </div>
                    </span>
                </td>
            );
        }

        return (
            <td className="configuration-price-column-container  --sales-price">
                <span className="configuration-price-column-container-content">
                    {this.salesPriceDiscountVisible() && <span>{value}</span>}
                    {this.salesPriceDiscountVisible() && <span className="discount">{this.props.row.discount}</span>}
                    <span>{this.props.row.discountedPrice}</span>
                </span>
            </td>
        );
    }

    factoryCostDiscountVisible = () => ProjectStore.formModel.summary.factoryDiscount.visible;

    renderFactoryCostColumn(column, value) {
        if (ProjectStore.factoryDiscountDuringEdit) {
            return (
                <td className="configuration-price-column-container">
                    <span className="configuration-price-column-container-content">
                        <span>{value}</span>
                        <div className="price-and-discount">
                            <div>
                                {this.renderNumberInput(`${this.props.row.id}-factory-discount`, this.props.row.factoryCostDiscountValue, value => {
                                    this.tester.record(() => {
                                        this.props.onConfiguratioRowPriceChanged('factoryCostDiscountValue', this.props.row.guid, value);
                                    });
                                })}
                                <span className="unit">%</span>
                            </div>
                            <div>
                                {this.renderNumberInput(`${this.props.row.id}-discounted-factory-cost`, this.props.row.discountedFactoryCostValue, value => {
                                    this.tester.record(() => {
                                        this.props.onConfiguratioRowPriceChanged('discountedFactoryCostValue', this.props.row.guid, value);
                                    });
                                })}
                                <span className="unit">EUR</span>
                            </div>
                        </div>
                    </span>
                </td>
            );
        }

        return (
            <td className="configuration-price-column-container">
                <span className="configuration-price-column-container-content">
                    {this.factoryCostDiscountVisible() && <span>{value}</span>}
                    {this.factoryCostDiscountVisible() &&
                        <span className="discount">{this.props.row.factoryCostDiscount}</span>}
                    <span>{this.props.row.discountedFactoryCost}</span>
                </span>
            </td>
        );
    }

    getDiscountValue(value) {
        let v = parseFloat(value);
        if (isNaN(v)) {
            v = 0;
        }

        return v;
    }
}
